import Highlighter from './Highlighter';
export * from './Highlighter';
export default Highlighter;
